/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host_",
                type: "address",
            },
            {
                internalType: "address",
                name: "z_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "NotAcceptedSuperToken",
        type: "error",
    },
    {
        inputs: [],
        name: "NotImplemented",
        type: "error",
    },
    {
        inputs: [],
        name: "UnauthorizedHost",
        type: "error",
    },
    {
        inputs: [],
        name: "CFAV1_TYPE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "flowRecipient",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
        ],
        name: "isAcceptedSuperToken",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "prevFlowRate",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "prevSender",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class CrossStreamSuperApp__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host_, z_, overrides) {
        return super.deploy(host_, z_, overrides || {});
    }
    getDeployTransaction(host_, z_, overrides) {
        return super.getDeployTransaction(host_, z_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
CrossStreamSuperApp__factory.bytecode = _bytecode;
CrossStreamSuperApp__factory.abi = _abi;
//# sourceMappingURL=CrossStreamSuperApp__factory.js.map